import { Component, OnInit, Input } from '@angular/core';
import { ApplicationPayment, PaymentItem } from "../../../../payments/models/paymentItem.model";


@Component({
    selector: 'payment-display',
    templateUrl: './payment-display.component.html',
    styleUrls: ['./payment-display.component.scss'],
    standalone: false
})
export class PaymentDisplayComponent implements OnInit {

    private _fees: ApplicationPayment[] = [];

    get payments(): ApplicationPayment[] {
        return this._fees;
    }

    @Input() set payments(value: ApplicationPayment[]) {
        this._fees = value;
    }

    get totalFees(): number {
        let fees: number = 0;
        if (this.payments != null) {
            this.payments.forEach(p => {
                fees = fees + p.fee;
            })
        }
        return fees;
    }

    constructor() { }

    ngOnInit() {
    }

}
